export default __webpack_public_path__ + "static/media/floor-4.df27522a.jpg";